const scenarios = [
  {
    title: "已有土地，想快速動工",
    icon: "ri-time-line",
    desc: "預製工法最適合「已經等不及」的業主。設計定稿後，工廠生產與基礎施工同步進行，大幅縮短總工期。",
    suitable: true,
  },
  {
    title: "重視品質穩定度",
    icon: "ri-shield-check-line",
    desc: "工廠標準化生產環境、每道工站品檢、追蹤碼管理，讓品質不再「看運氣」。",
    suitable: true,
  },
  {
    title: "地震帶或高風壓地區",
    icon: "ri-earthquake-line",
    desc: "輕量化鋼構 + 高韌性鋼材，耐震性能優異，適合台灣地震頻繁的地理環境。",
    suitable: true,
  },
  {
    title: "預算需要精準可控",
    icon: "ri-coins-line",
    desc: "工廠報價透明、變更少、追加預算機率低，適合對預算控管有嚴格要求的業主。",
    suitable: true,
  },
  {
    title: "追求節能與淨零",
    icon: "ri-leaf-line",
    desc: "高效斷熱牆板 + 氣密設計，全年空調用電降低 30–50%，符合未來趨勢。",
    suitable: true,
  },
  {
    title: "特殊造型或超大跨度",
    icon: "ri-building-line",
    desc: "RC 在特殊造型、大跨度、自由曲線方面仍有優勢。若建築造型極為複雜，可考慮混合工法。",
    suitable: false,
  },
];

export default function ScenariosSection() {
  return (
    <section className="py-14 md:py-20 bg-warm-gray">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">SUITABILITY GUIDE</span>
          <h2 className="mb-3">什麼樣的業主適合預製工法？</h2>
          <p className="text-medium-gray max-w-2xl mx-auto">
            預製工法並非萬能，但在多數自建情境下具有明顯優勢。以下幫助你判斷是否適合。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {scenarios.map((s) => (
            <div
              key={s.title}
              className={`bg-white rounded-xl border p-5 transition-all duration-300 hover:shadow-md ${
                s.suitable ? "border-warm-gray/20 hover:border-champagne/30" : "border-warm-gray/20"
              }`}
            >
              <div className="flex items-start gap-3 mb-3">
                <span className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${
                  s.suitable ? "bg-champagne/10 text-champagne" : "bg-warm-gray/30 text-medium-gray"
                }`}>
                  <i className={`${s.icon} text-lg`} />
                </span>
                <div>
                  <h4 className="text-base font-bold text-graphite">{s.title}</h4>
                  {s.suitable && (
                    <span className="inline-block mt-1 px-2 py-0.5 rounded text-xs font-semibold bg-emerald-50 text-emerald-700">
                      高度適合
                    </span>
                  )}
                  {!s.suitable && (
                    <span className="inline-block mt-1 px-2 py-0.5 rounded text-xs font-semibold bg-warm-gray/40 text-medium-gray">
                      建議評估
                    </span>
                  )}
                </div>
              </div>
              <p className="text-sm text-medium-gray leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}